var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header',{staticClass:"header"}),_c('div',{staticClass:"router-view"},[_c('router-view',{key:_vm.key})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }